export default __webpack_public_path__ + "static/media/Extentus.8676a193.jpg";